import React from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ListIcon from '@material-ui/icons/List';
import Slide from '@material-ui/core/Slide';
import ShowTransactions from './ShowTransactions';
import { translate } from 'react-admin';
import ShowCalls from './ShowCalls';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class PopUpTable extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, transactions, table1, table2, header1, header2, translate,name } = this.props;
    return (
      <div>
        <Button variant="extendedFab" color="primary" onClick={this.handleClickOpen} >
            {(name==='units')&&translate('trans.useUnits')}
            {(name==='calls')&&translate('trans.callStats')}
            <ListIcon/>
        </Button>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          {(name==='units')&&<ShowTransactions transactions={transactions} />}
          {(name==='calls')&&<ShowCalls table1={table1} table2={table2} header1={header1} header2={header2}  />}
        </Dialog>
      </div>
    );
  }
}

PopUpTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(translate(PopUpTable));